import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'success' | 'warning' | 'info';
}
export function Badge({
  children,
  variant = 'success'
}: BadgeProps) {
  const variants = {
    success: 'bg-[var(--viridia-green)] text-white',
    warning: 'bg-yellow-500 text-white',
    info: 'bg-blue-500 text-white'
  };
  return <span className={`inline-block px-3 py-1 rounded-full text-sm font-semibold ${variants[variant]}`} data-id="element-278">
      {children}
    </span>;
}